import TweenMax from 'gsap/TweenMax';

export default function BumpInner(
  container,
  canvas,
  duration,
  beforeAnimation
) {
  const {
    top: containerTop,
    left: containerLeft,
    width: containerWidth,
  } = container.getBoundingClientRect();

  const {
    bottom: canvasBottom,
    height: canvasHeight,
    left: canvasLeft,
    width: canvasWidth,
  } = canvas.getBoundingClientRect();
  const initialX =
    canvasLeft - containerLeft + (canvasWidth - containerWidth) / 2;
  const initialY = canvasBottom - containerTop - (40 / 100) * canvasHeight;

  beforeAnimation(initialX, initialY);

  TweenMax.to(container, 0.25, {
    opacity: 1,
  });
}
